// @flow

import React, { type Node } from 'react';
import { TipsBox } from '@tectonics/look-and-feel/shopify-embedded/organisms/tips-box';

import qrCode from './qr-code.svg';
import downloadQrCode from './download-qr-code.svg';
import styled from 'styled-components';

export function PaymentInstructions(): Node {
  return (
    <Root>
      <TipsBox title="Instrucciones de pago" tipsModel={[
        {
          imgSrc: qrCode,
          altText: 'qrcode icon',
          tipText: `
            Paga escaneando el código QR con
            NEQUI en tu teléfono móvil.
          `,
        },
        {
          imgSrc: downloadQrCode,
          altText: 'download qrcode icon',
          tipText: `
            Descarga el código QR y paga
            cargando la imágen en tu NEQUI
            app.
          `,
        },
      ]} />
    </Root>
  );
}

const Root = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 5px;
`;
